<div class="modal" tabindex="-1" role="dialog" data-at="modal-field">
  <div class="modal__content">
    <div class="modal__content__header">
      <div class="navbar navbar--sub">
        <div class="navbar__section navbar__section--title">
          {{ data.title | translate }}
        </div>
        <div class="navbar__section navbar__section--right">
          <button type="button" (click)="close()" data-at="button-close">
            <i data-icon="close"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="modal__content__body">
      <gk-add-user-form
        *ngIf="user"
        (saveForm)="saveUser()"
        (modalCloseEvent)="close()"
        [user]="user"
        [roleList]="roleList"
        [businessList]="businessList"
      >
      </gk-add-user-form>
    </div>
  </div>
</div>
